import { render, staticRenderFns } from "./AggregatorTransactionDetail.vue?vue&type=template&id=262327d8"
import script from "./AggregatorTransactionDetail.vue?vue&type=script&lang=js"
export * from "./AggregatorTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports